import React from 'react';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import styled from '@emotion/styled';
import { noop } from 'lodash';
import ReorderClickItem from 'components/exercise/reorder_click_item';
import { ExerciseUI } from '@seedlang/state';
import { Badge } from '@mantine/core';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: ${props => props.isScrollable ? 'nowrap' : 'wrap'};
  justify-content: ${props => props.center ? 'center' : 'flex-start'};
`;

const GapWordWrapper = styled.div`
  margin: 0 5px 5px 0;
`;

@observer
class ExerciseWordAssociations extends React.Component {

  static defaultProps = {
    showAssignedSlots: true,
  };

  @computed get isScrollable() {
    return this.props.mobileScrollable && ExerciseUI.layout.isMobile;
  }

  render() {
    return (
      <Wrapper
        center={this.props.center}
        isScrollable={this.isScrollable}
      >
        {
          this.props.wordAssociations && this.props.wordAssociations.map(item => {
            if (!this.props.showAssignedSlots && item.state.assigned) {
              return null;
            }

            return (
              <GapWordWrapper
                key={item.id}
              >
                {
                  !this.props.clickable &&
                    <Badge color='cyan' size='lg' mr='5px' style={{ textTransform: 'none' }}>
                      {item.targetText.normalize('NFC')}
                    </Badge>
                }
                {
                  this.props.clickable &&
                    <ReorderClickItem
                      onClick={() => item.state.assigned ? noop : this.props.onClick(item, this.props.sentence && this.props.sentence.id, this.props.clickWithinSentence)}
                      height={this.props.inDeck ? '50px' : '40px'}
                      assigned={item.state.assigned}
                      fontSize={this.props.sentence?.rightToLeftLanguage ? '16px' : '14px'}
                      inDeck={this.props.inDeck}
                      whiteSpace={this.isScrollable ? 'nowrap' : 'normal'}
                    >
                      {item.targetText.normalize('NFC')}
                    </ReorderClickItem>
                }
              </GapWordWrapper>
            );
          })
        }
      </Wrapper>
    );
  }
}

export default ExerciseWordAssociations;
